import React from 'react';
import RefoundBackbookISP from 'Route/TriggerTimeline/components/RefoundBackbookISP';
import RefoundUnavailable from 'Route/TriggerTimeline/components/RefoundUnavailable';
import NewsHomePopups from 'Route/TriggerTimeline/components/NewsHomePopups';
import MessagesHomePopups from 'Route/TriggerTimeline/components/MessagesHomePopups';
import KitStartTtl from 'Route/TriggerTimeline/components/KitStartTtl';
import AmlPopup from 'Route/TriggerTimeline/components/AmlPopup';
import ConsentsPopup from 'Components/ConsentsPopup/ConsentsPopupContainer';
import TutorialPopup from 'Components/TutorialPopup';

export const elementsMap = {
  NEWS: <NewsHomePopups />,
  MESSAGE: <MessagesHomePopups />,
  REFUND_BACKBOOK_ISP: <RefoundBackbookISP />,
  REFUND_UNAVAILABLE: <RefoundUnavailable />,
  KIT_START: <KitStartTtl />,
  AML: <AmlPopup fromTTL={true} /> ,
  CONSENTS: <ConsentsPopup />,
  TUTORIAL: <TutorialPopup />
};

export default elementsMap;
